export default "__VITE_ASSET__BYTWwW7u__"